import { render, staticRenderFns } from "./form-number.vue?vue&type=template&id=87c0999c&"
import script from "./form-number.vue?vue&type=script&lang=js&"
export * from "./form-number.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "form-number.vue"
export default component.exports